import { observable, action } from 'mobx'

class LayoutStore{

}

const layoutStore = new LayoutStore();
export default layoutStore